<template>
  <main>
    <tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container" :class="{ 'section-loading': isLoading }">
          <div class="row">
            <div class="col-12">
              <div class="row-1">
                <div class="col-2 dial-person-title row-1_1">選擇撥出對象</div>
                <div class="col-5 row-1_2" v-if="type == '1'">
                  <span class="dialout_person text-black">{{ dialOut.person.label }}</span>
                </div>
                
                <div class="col-5 row-1_2"
                  v-else-if="type == '4' && resignType == '1' && resignStatus == '1A'">
                  <span v-for="(item, index) in dialOut.selected" :key="index" class="dialout_person">
                    {{ item.resign_name }} {{ item.resign_ceclcno }}
                  </span>
                </div>
                <div class="col-5 row-1_2" v-else-if="type == '5'">
                  <span v-for="(item, index) in dialOut.selected" :key="index" class="dialout_person">
                    {{ item.ceempnm }} {{ item.clcno }}
                  </span>
                </div>
                <div class="col-5 row-1_2" v-else>
                  <span class="dialout_person"></span>
                </div>
                <div class="col-2 row-1_3">
                  <label class="mr-2">已選:</label>
                  <span>{{ countSelectedDialoutIds }}戶 / {{ countSelectedDialoutDatas }}件</span>
                </div>
                <div class="col-3 row-1_4">
                  <label class="mr-2">本次智能配對:</label>
                  <span>{{ countSmartPairDialoutIds }}戶 / {{ countSmartPairDataLength }}件</span>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-2 dial-person-title">撥入對象搜尋</div>
              </div>
            </div>
          </div>
          <div class="row-2 mb-5">
            <div class="row-2-1 mb-2">
              <label class="mr-2">以收費代號搜尋</label>
              <input type="text"
                     v-model="searchData.clcno_new" 
                     class="form-control mr-3"
                     maxlength="7">
              <label class="mr-2">以要保人姓名搜尋</label>
              <input type="text"
                     v-model="searchData.ceapcnm"  
                     class="form-control">
            </div>
            <div class="row-2-1">
              <label class="mr-2">以保單號碼搜尋</label>
              <input type="text"
                     v-model="searchData.ceplcno"   
                     class="form-control mr-3"
                     maxlength="10">
              <label class="mr-2">以要保人ID搜尋</label>
              <input type="text"
                     v-model="searchData.ceapcno"  
                     class="form-control"
                     maxlength="10">
              <a @click="search" class="btn btn-primary dialin-search-btn">搜尋</a>
            </div>
          </div>
          <div class="mt-5">
            <div v-if="countSmartPairDataLength !== 0" v-for="(group, index) in smartPairGroup" :key="index" class="group-container">
              <div class="dialin-person-title" @click="toggleTable(index)">
                <div class="toggle-btn">{{ toggleIcon(index) }}</div>
                <div class="col-3 text-white">
                  <label class="mr-2 cursor">受撥同仁</label>
                  <span>{{ getPairDialinPersonName(group, index) }} {{ getPairDialinPersonClcno(group, index) }}</span>
                </div>
                <div class="col-5-custom text-white">
                  <label class="mr-2 cursor">服務件數(自招/非自招):</label>
                  <span>{{ groupInsuranceCount(group, index) }}件</span><span class="ml-3">人數: {{ groupCustomerCount(group, index) }}人</span>
                </div>
                <div class="col-3 text-white">
                  <label class="mr-2 cursor">撥入客戶:</label>
                  <span>{{ countGroupDialoutIds(group) }}戶 / {{ countGroupDataLength(group) }}件</span>
                </div>
              </div>


              <div class="table-wrapper" v-if="group.showTable">
                <table class="table datatable table-striped">
                  <thead>
                    <tr>
                      <th>
                        <div class="checkbox checkbox-inline mr-0">
                          <input type="checkbox" :name="`${index}-check-all`" :id="`${index}-check-all`"
                            v-model="selectAll[index]" @change="selectAllRows(index)">
                          <label :for="`${index}-check-all`"></label>
                        </div>
                      </th>
                      <th>待撥出客戶</th>
                      <th>保單號碼</th>
                      <th>自招件</th>
                      <th>契約效力</th>
                      <th>同單位服務人員</th>
                      <th>調撥期限</th>
                      <th>整合地址</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, rowIndex) in group.pairDatas" :key="rowIndex">
                      <td>
                        <div class="checkbox checkbox-inline mr-0">
                          <input type="checkbox" :name="`${index}-check-all-${rowIndex}`"
                            :id="`${index}-check-all-${rowIndex}`" v-model="rowSelection[index][rowIndex]"
                            @change="updateSelection(row, index, rowIndex)">
                          <label :for="`${index}-check-all-${rowIndex}`"></label>
                        </div>
                      </td>
                      <td>
                        <span
                            class="d-inline-block text-center align-middle mr-1"
                          >
                            <level :lv="Number(row.vip)" />
                            <avatar
                              :gender="Number(row.ceapcno[1])"
                              :size="20"
                            />
                        </span>
                        <span class="name align-middle">
                            {{ row.ceapcnm }}
                        </span>
                      </td>
                      <td>{{ row.ceplcno }}</td>
                      <td>{{ checkCeagent(row.ceagent) }}</td>
                      <td>{{ row.celpscs_nm }}</td>
                      <td>{{ row.other_ceclcnm }}</td>
                      <td>{{ row.deadline }}</td>
                      <td>{{ row.d2_payaddr }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-else-if="countSmartPairDataLength == 0" class="group-container">
              <div class="dialin-person-title">
                <div class="toggle-btn" @click="toggleTable(index)">{{ toggleIcon(index) }}</div>
                <div class="col-3 text-white">
                  <label class="mr-2">本月無智能配對結果</label>
                </div>
              </div>
              <div class="no-pairdata">
                <div class="col-12">
                  <label>以當前智能配對條件下，本月並無產生智能配對結果</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="countSmartPairDataLength !== 0">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <a @click="goBack()" class="btn btn-default">上一步</a>
                <a @click="goNext()" class="btn btn-primary">下一步</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <warning-modal 
        :open="warningModalOpen" 
        :message="warningMessage" 
        @close="panelClose('warningModalOpen')"
        @submit="submit" />
    </div>
  </main>
</template>



<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import TabHeader from '@/desktop/components/manager/TabHeader'
import Avatar from '@/components/Avatar'
import Level from '@/components/Level'
import WarningModal from '@/desktop/components/WarningModal'
import ceadcdChooseModal from '../manager/condition/components/ceadcdChooseModal'
import {querySmartMappingData, insertServiceRecord2} from '../../../service';

export default {
  name: 'TransferTab1SmartMaching',
  mixins: [commonMixin],
  components: {
    TabHeader, Level, Avatar, ceadcdChooseModal, WarningModal
  },
  computed: {
    ...mapGetters(["RouterPara"]),
    toggleIcon(){
      return (index) => ( this.smartPairGroup[index] && this.smartPairGroup[index].showTable ) ? '–' : '+' ;
    },
    getPairDialinPersonName(){
      return (group) => ( group && group.ceclcnm_new ) ? group.ceclcnm_new : "" ;
    },
    getPairDialinPersonClcno(){
      return (group) => ( group && group.clcno_new ) ? group.clcno_new : "" ;
    },
    countGroupDialoutIds(){
      return (group) => ( group && group.pairDatas && group.pairDatas.length > 0  ) ? (new Set(group.pairDatas.map( item => item.ceapcno )).size) : 0 ;
    },
    countGroupDataLength(){
      return (group) => ( group && group.pairDatas && group.pairDatas.length > 0  ) ? group.pairDatas.length : 0 ; 
    },
    groupInsuranceCount(){
      return (group) => ( group && group.pairDatas && group.pairDatas.length > 0 ) ? group.pairDatas[0].tmp1 + ' / ' +  group.pairDatas[0].tmp2 : 0 ;
    },
    groupCustomerCount(){
      return (group) => ( group && group.pairDatas && group.pairDatas.length > 0  ) ? group.pairDatas[0].cs_count : 0 ;
    },
    countSelectedDialoutIds() {
      let totalCount = 0;
      this.selection.forEach((group) => {
        const uniqueDialoutIds = new Set(group.conditions.map((condition) => condition.ceapcno));
        totalCount += uniqueDialoutIds.size;
      });
      return totalCount;
    },
    countSelectedDialoutDatas() {
      let totalCount = 0;
      this.selection.forEach((group) => {
        const groupDatas = group.conditions.length
        totalCount += groupDatas
      });
      return totalCount;
    },
  },
  data () {
    return {
      dialOut: {},
      type: '', //選擇撥出的種類： 1: 撥出人員  4: 地址  5: 類別對象
      resignType: '',
      // dialOut_person: '',
      resignStatus: '',
      smartPairGroup: [
        { ceclcid_new: '',
          ceclcnm_new: '',
          clcno_new: '',
          showTable: false,
          pairDatas: [],
        },
      ],
      searchData: {
        clcno_new: '', //收費代號
        ceapcno: '', //要保人id
        ceapcnm: '', //要保人姓名
        ceplcno: ''  //保單號碼
      },
      inputLengthLimit: {
        clcno_new: 7,
        ceapcno: 10,
        ceplcno: 10,
      },
      selectAll: true, //預設全選
      selection: [], //選取的資料
      rowSelection: [], //處理checkbox顯示
      isLoading: false,
      countSmartPairDialoutIds: 0, //智能配對總戶數
      countSmartPairDataLength: 0, //智能配對總件數
      allAgents: [],
      warningModalOpen: false,
      warningMessage: "您是否確認要進行服務件調撥？"
    }
  },
  watch: {

  },  
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    checkCeagent(value){
      return value !== '' ? (value == 0 ? '否' : '是' ) : ''   
    },
    search() {
      const inputData = Object.fromEntries(
        Object.entries(this.searchData).filter(([key, value]) => value !== '')
      );

      for (const key in inputData) {
          // 要保人姓名ceapcnm 不需檢核長度
          if (this.searchData[key].length !== this.inputLengthLimit[key] && key !== 'ceapcnm') {
            this.$toast.info({ title: '此查詢條件查無資料' })
            return;
          }
      }

      if (Object.keys(inputData).length !== 0) {
        let foundMatch = false; // 追蹤是否找到匹配的資料

        for (let groupIndex = 0; groupIndex < this.smartPairGroup.length; groupIndex++) {
          const group = this.smartPairGroup[groupIndex];
          const matchingIndexes = group.pairDatas.reduce((acc, row, index) => {
            // 檢查 row 是否與 inputData 中的所有鍵值對都匹配
            if (Object.entries(inputData).every(([key, value]) => row[key] === value)) {
              acc.push(index);
            }
            return acc;
          }, []);

          if (matchingIndexes.length > 0) {
            foundMatch = true; // 找到匹配的資料
          }

          // 更新表格的顯示狀態
          this.$set(this.smartPairGroup, groupIndex, { ...group, showTable: matchingIndexes.length > 0 });

          // 更新選擇狀態
          const newSelection = Array(group.pairDatas.length).fill(false);
          matchingIndexes.forEach(index => {
            newSelection[index] = true;
          });
          this.$set(this.rowSelection, groupIndex, newSelection);

          // 更新 selection 中的 conditions 
          this.$nextTick(() => {
            if (matchingIndexes.length > 0) {
              this.selection[groupIndex].conditions = matchingIndexes.map(index => group.pairDatas[index]);
            } else {
              this.selection[groupIndex].conditions = [];
            }
            // 檢查是否需要勾選全選框
            if (matchingIndexes.length === group.pairDatas.length) { 
              this.selectAll[groupIndex] = true; 
            } else { 
              this.selectAll[groupIndex] = false; 
            } 
          });

        }

        if (!foundMatch) {
          // 如果找不到匹配的資料，顯示提示並退出方法
          this.$toast.info({ title: '查無資料' })
          return;
        }

        this.selectAll = this.selectAll.map(() => false);

        this.registerHanlink();
      }
    },
    toggleTable(index){
      this.registerHanlink();
      if(this.smartPairGroup[index]){
        this.$set(this.smartPairGroup, index, {
        ...this.smartPairGroup[index],
        showTable: !this.smartPairGroup[index].showTable,
       })
      }
    },
    selectAllRows(index) {
      if (this.smartPairGroup[index]) {
          const selectAllValue = this.selectAll[index];

          // 如果 selectAll 變為 true，則將所有 row 加入 selection 中的 conditions
          if (selectAllValue) {
            this.selection[index].conditions = [...this.smartPairGroup[index].pairDatas];
            // 更新 rowSelection，使所有 checkbox 選中
            this.$set(this, 'rowSelection', { ...this.rowSelection, [index]: Array(this.smartPairGroup[index].pairDatas.length).fill(true) });
          } else {
            // 如果 selectAll 變為 false，則清空 selection 中的 conditions
            this.selection[index].conditions = [];
            // 更新 rowSelection，使所有 checkbox 不選中
            this.$set(this, 'rowSelection', { ...this.rowSelection, [index]: Array(this.smartPairGroup[index].pairDatas.length).fill(false) });
          }
        }
    },
    updateSelection(row, groupIndex, rowIndex) {
      if (this.smartPairGroup[groupIndex]) {
        const currentTableDatas = this.smartPairGroup[groupIndex].pairDatas;
        const status = this.rowSelection[groupIndex][rowIndex];

        currentTableDatas.forEach((condition, index) => {
          if (condition.ceapcno === row.ceapcno) {
            this.$set(this.rowSelection[groupIndex], index, status);
          }
        });

        // 在 $nextTick 內進行 selection 的更新
        this.$nextTick(() => {
          this.selection[groupIndex].conditions = currentTableDatas.filter((condition, index) => {
            return this.rowSelection[groupIndex][index];
          });
        });
      }
    },
    goBack(){
      this.$router.back();
    },
    goNext(){
      //未勾選任何資料時需卡控提示
      let hasSelectedData = false;
      for (let groupIndex = 0; groupIndex < this.smartPairGroup.length; groupIndex++) {
        if (this.selection[groupIndex].conditions.length > 0) {
          hasSelectedData = true;
          break;
        }
      }
      if (!hasSelectedData) {
        this.$toast.info({ title: "請至少選擇一名客戶" });
        return 
      } 
      this.panelOpen('warningModalOpen')
    },
    submit(){  
      insertServiceRecord2(
          this.$store.state.userInfo.id,
          this.selection,
          this.$store.state.userInfo.name
        ).then(result => {
          this.buttonDisabled = false;
          this.confirmText = "確定";

          if (result.header && result.header.status === "200") {
            this.$toast.info({ title: "服務件調撥已完成！" });
            if (
              this.$store.state.userInfo.roleId == "SALES_MANAGER_02" ||
              (this.$store.state.userInfo.roleId == "SALES_MANAGER_06" &&
                this.$store.state.userInfo.functionId &&
                this.$store.state.userInfo.functionId.includes("3"))
            ) {
              //  如果是大主管
              this.$router.push({ name: "transfer-tab1" });
            } else {
              //  如果是小主管
              this.$router.push({ name: "sub-transfer-tab-1" });
            }
          } else {
            if (result.header && result.header.message) {
              this.$toast.info({ title: result.header.message });
            } else {
              this.$toast.info({ title: "系統連線異常,請稍後再試" });
            }
          }
          this.isInsertApiLoading = false;
      });

    },             
    init(){
      this.isLoading = true;
      this.dialOut = this.RouterPara.dialOutData.data
      this.resignType = this.RouterPara.dialOutData.resignType
      this.type = this.RouterPara.dialOutData.type
      this.resignStatus = this.RouterPara.dialOutData.resignStatus
      this.allAgents = this.RouterPara.dialOutData.allAgents
      const reqData = {
        cedvno3 : this.$store.state.userInfo.divNo.slice(0,3),
        type: this.type
      };
      switch(this.type){
        case '1': //'person'
          reqData.clcno = this.dialOut.person.code
          break;
        case '4': //'address'
          reqData.zip = this.dialOut.address[1]
          reqData.addr = this.dialOut.address[2]
          break;
        case '5': //'selected'
          reqData.clcno_s = []
          if( this.dialOut.selected[0].producer_segment == 'A' && this.resignType =='1' ){
            this.dialOut.selected.forEach(item => 
              reqData.clcno_s.push(item.resign_ceclcno) 
            )
          }else{
            this.dialOut.selected.forEach(item => 
              reqData.clcno_s.push(item.clcno) 
            )
          }
          reqData.segment = this.dialOut.selected[0].producer_segment
          break;

      }
      querySmartMappingData(this.$store.state.userInfo.id, reqData).then(result => {
        if (result.header && result.header.status == '200') {
          const responeData = result.body.smartpairdatalist
          this.countSmartPairDataLength = responeData.length //所有智能配對總件數
          
          if(this.countSmartPairDataLength !== 0){
              responeData.forEach(data => {
                if (data.cenxpdt === "1911-01-01") {
                  // 判別日期
                  data.cenxpdt = "";
                }
                if (data.idmark) {
                  if (data.idmark.includes("G")) {
                    // 判別VIP 黃金
                    data.vip = 5;
                  } else if (data.idmark.includes("P")) {
                    // 判別VIP 白金
                    data.vip = 6;
                  } else if (data.idmark.includes("D")) {
                    // 判別VIP 鑽石
                    data.vip = 7;
                  }
                } else {
                  data.idmark = "";
                  data.vip = 0;
                }
              });

            //過濾重複的待撥出客戶id，獲取總戶數
            let allDialoutPersonId = responeData.map( item => item.ceapcno) //所有待撥出客戶id
            const ids = new Set(allDialoutPersonId); 
            this.countSmartPairDialoutIds = ids.size

            const groupsMap = {}
            responeData.forEach(item =>{
              //將智能配對資料逐一以新業務員id去比對所有服務人員之id，配對者加入服務件數與要保人數
              let matchingData = this.allAgents.find(agent => item.ceclcid_new === agent.agidno);
              if (matchingData) {
                item.tmp1 = matchingData.tmp1;
                item.tmp2 = matchingData.tmp2;
                item.cs_count = matchingData.cs_count;
              }else{
                item.tmp1 = 0;
                item.tmp2 = 0;
                item.cs_count = 0;
              }

              //進行分類： ceclcid_new相同的資料分成一類 
              const key = `${item.ceclcid_new}-${item.ceclcnm_new}-${item.clcno_new}`
              if(!groupsMap[key]){
                groupsMap[key] = {
                  ceclcid_new: item.ceclcid_new,
                  ceclcnm_new: item.ceclcnm_new,
                  clcno_new: item.clcno_new,
                  showTable: false,
                  pairDatas:[],
                };
              }
              groupsMap[key].pairDatas.push(item)
            })
            this.smartPairGroup = Object.values(groupsMap)
            this.smartPairGroup.forEach(group => {
              group.pairDatas.sort((a, b) => {
                if (a.ceapcnm < b.ceapcnm) {
                  return -1;
                }
                if (a.ceapcnm > b.ceapcnm) {
                  return 1;
                }
                return 0;
              });
            });
            this.selectAll = Array(this.smartPairGroup.length).fill(false);
            this.selection = this.smartPairGroup.map((group) => ({
              conditions: [], // [...group.pairDatas] 此為預設全選
              inAgentInfo:{
                ceclcar_new1: group.pairDatas[0].clcno_new,
                ceclcid_new: group.pairDatas[0].ceclcid_new, 
                ceclcnm_new: group.pairDatas[0].ceclcnm_new, 
                jcode_new: group.pairDatas[0].jcode_new,  
                producer_segment_in: group.pairDatas[0].producer_segment,  
                tmp4_in: group.pairDatas[0].tmp4_in || "",
                clcno_new: group.pairDatas[0].clcno_new,
              },
              dialInCode: group.clcno_new,
              type: this.type
            }));
            this.rowSelection = this.smartPairGroup.map(group => Array(group.pairDatas.length).fill(false));
          }
          this.isLoading = false
          setTimeout(()=>{
            this.registerHanlink();
          },50)
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message })
          } else {
            this.$toast.info({ title: '查詢智能配對失敗' });
          }
        }
      })
    }
  },
  mounted () {
    this.init();
  }
}
</script>
<style scoped>
.cus-p{
  margin: 0 0 5px 0;
}

.dial-person-title{
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 20px;
  color: #027A39;
  font-weight: bold;
}

.col-5-custom{
  -webkit-box-flex: 0;
  -ms-flex: 0 0 46%;
  flex: 0 0 46%;
  max-width: 46%;

}

.row-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-right: -10px;
  margin-left: -10px;
}

.row-2{
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  margin-right: -10px;
  margin-left: -10px;
  position: relative;
}

.row-2 div {
  width: 70%;
}


.row-2 input .form-control{
  width: 40%;
}

.row-2 .row-2-1{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 50px;
}

.row-2-1 label{
  width: 60%;
}

.dialin-search-btn{
  position: absolute;
  right: 5%;
}

.toggle-btn{
  cursor: pointer;
  font-size: 24px;
  color: #fff;
  text-align: center;
  width: 30px;
  margin-left: 10px;
}

.dialin-person-title{
  cursor: pointer;
  border-radius: 8px;
  background-color: #198C25;
  width: 100%;
  height: 45px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.cursor {
  cursor: pointer;
}

.text-black {
  color: black !important;
}

.dialout_person{
    border-color: transparent;
    color: #989ca2;
    background: #F5F5F5;
    -webkit-box-shadow: inset 0 -1px 0 0 #e2e2e2;
    -ms-box-shadow: inset 0 -1px 0 0 #e2e2e2;
    -o-box-shadow: inset 0 -1px 0 0 #e2e2e2;
    box-shadow: inset 0 -1px 0 0 #e2e2e2;
    padding: 12px;
    display: inline-block;
    word-wrap: break-word;
    min-width: 140px;
    min-height: 36px;
    text-align: center;
}

.table.datatable , .table.datatable thead tr > th  {
  background-color: #F5F5F5 !important;
}

.table.datatable thead tr > th , .table.datatable tbody tr > td {
  font-size: 20px !important; 
  color: #027A39 !important; 
  text-align: center !important;
}

.table.datatable thead tr > th {
  border: 0 !important;
  border-bottom: 2px solid #C2C4C7 !important;
}

.table.datatable tbody tr > td {
  border: 0 !important;
}

table.table {
  border: 0px !important;
}

.group-container{
  position: relative;
  margin: 0px -10px 30px -10px;
}

.t-r{
  text-align: right;
}

.no-pairdata{
  width: 100%;
  height: 200px;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  text-align: center;
}




</style>
